import {createRouter, createWebHistory} from 'vue-router';
import {useAuthStore} from "@/stores/authStore.js";

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/LoginView.vue'),
    },
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/HomeView.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import('@/views/Orders.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/situation-report',
        name: 'situation-report',
        component: () => import('@/views/SituationReport.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/purchase-by-supplier',
        name: 'purchase-by-supplier',
        component: () => import('@/views/Purchase.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/purchase-list',
        name: 'purchase-list',
        component: () => import('@/views/PurchaseList.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/purchase-by-product',
        name: 'purchase-by-product',
        component: () => import('@/views/Purchase.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/not-listed-supplier/:id',
        name: 'not-listed-supplier',
        component: () => import('@/views/Purchase.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/receiving-list',
        name: 'receiving-list',
        component: () => import('@/views/ReceivingList.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/stocks',
        name: 'stocks',
        component: () => import('@/views/Stocks.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/price-list',
        name: 'price-list',
        component: () => import('@/views/PriceList.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/SettingsView.vue'),
        meta: {requiresAuth: true},
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Auth guard based on Pinia
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();

    if (to.meta.requiresAuth && !authStore.token) {
        next({ name: 'login', query: { redirect: to.fullPath } });
    } else if (to.name === 'login' && authStore.token) {
        next({ name: 'home' });
    } else {
        next();
    }
});

export default router;